import { CreditLimitRequest, CreditResponse, GetCreditReportsResponse, GetCreditResponse, TransactionTypes } from 'Application/models';
import { APICallInstance } from './APICallInstance';
import { AxiosResponse } from 'axios';

export const addCredit = async (creditData: CreditLimitRequest, agencyId: any) => {
    const url = `api/v1/credit-limits/${agencyId}`;

    try {
        const response: AxiosResponse<CreditResponse> = await APICallInstance.post(url, creditData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const fetchCredit = async (agencyName: string) => {
    const url = `/api/v1/credit-limits`;

    try {
        const response: AxiosResponse<GetCreditResponse> = await APICallInstance.get(url,{

            params: {
                agencyName: agencyName,
               
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const fetchCreditReports = async (agencyName: string, type: TransactionTypes, page: number, pageSize: number) => {
    const url = `/api/v1/agency/credit?agencyName=${agencyName}&type=${type}&page=${page}&pageSize=${pageSize}`;

    try {
        const response: AxiosResponse<GetCreditReportsResponse> = await APICallInstance.get(url);
        console.log(response);
        return response.data;
    } catch (error) {
        console.error('Error fetching credit reports', error);
        throw error;
    }
};
